import { useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { usAdminAppRoutes } from "route-definitions";
import BaseModal from "../shared/components/BaseModal";
import BaseButton from "components/common/BaseButton";
import useMutateTerritoryManager from "./hooks/useMutateTerritoryManager";
import CreateTerritoryManagerForm from "./components/create-territory-manager-form/CreateTerritoryManagerForm";
import { TerritoryManagerFormData } from "./components/create-territory-manager-form/create-territory-manager.schema";
import EntityPageLayout from "../shared/components/EntityPageLayout";

const CreateTerritoryManagersPage = () => {
  const history = useHistory();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const intl = useIntl();

  const {
    createTerritoryManager,
    createTerritoryManagerLoading,
    createTerritoryManagerSuccess,
    createTerritoryManagerError,
  } = useMutateTerritoryManager({
    onCreateSuccess: () => {
      setModalIsOpen(true);
    },
    onCreateError: () => {
      setModalIsOpen(true);
    },
  });

  const onSubmit = (data: TerritoryManagerFormData) => {
    createTerritoryManager(data);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    if (createTerritoryManagerSuccess) {
      history.push(usAdminAppRoutes.territoryManagers);
    }
  };

  return (
    <EntityPageLayout headerMessage="usAdmin.createTerritoryManager">
      <BaseModal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        footer={
          <BaseButton
            handleSubmit={handleCloseModal}
            text={intl.formatMessage({ id: "usAdmin.ok" })}
          />
        }
      >
        {createTerritoryManagerSuccess && (
          <h2>
            {intl.formatMessage({
              id: "usAdmin.territoryManagerCreatedSuccessfully",
            })}
          </h2>
        )}
        {createTerritoryManagerError && (
          <h2>
            {intl.formatMessage({ id: "usAdmin.territoryManagerExists" })}
          </h2>
        )}
      </BaseModal>
      <CreateTerritoryManagerForm
        onSubmit={onSubmit}
        isSubmitting={createTerritoryManagerLoading}
      />
    </EntityPageLayout>
  );
};

export default CreateTerritoryManagersPage;
